// extracted by mini-css-extract-plugin
module.exports = {"container":"Experience_container__23cjL","heading":"Experience_heading__10N9J","content_p":"Experience_content_p__2WekG"};